import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './CartTaxAndDuties.module.scss'

export interface CartTaxAndDutiesProps {
  className?: string
}

export const CartTaxAndDuties: FC<CartTaxAndDutiesProps> = ({ className }) => {
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)
  const showDutiesExclSalesTax = ['27', '36', '29', '28', '32'].includes(store.id)
  const showAllDutiesIncluded = ['19', '20', '3', '8', '33', '34', '21'].includes(store.id)
  if (!showDutiesExclSalesTax && !showAllDutiesIncluded) {
    return null
  }
  return (
    <p className={clsx(styles.cartTaxAndDuties, className)}>
      {showDutiesExclSalesTax && t('common:DUTIES_EXCL_SALES_TAX')}
      {showAllDutiesIncluded && t('header:ALL_DUTIES_AND_TAXES_INCLUDED', '[All duties and taxes included]')}
    </p>
  )
}
